"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReanimatedBottomSheetHeader = void 0;
const react_1 = __importDefault(require("react"));
const accessibility_1 = require("../../../../../shared/accessibility");
const ReanimatedBottomSheetContext_1 = require("../ReanimatedBottomSheetContext");
const S = __importStar(require("./ReanimatedBottomSheetHeader.styles"));
const atoms_1 = require("../../../atoms");
exports.ReanimatedBottomSheetHeader = ({ title = '', showCloseButton = true, disableCloseButton = false, handleClosePress = () => { }, }) => {
    const { state: { scrollY }, } = ReanimatedBottomSheetContext_1.useReanimatedBottomSheet();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(S.Header, { borderBottom: scrollY > 0 },
            title ? (react_1.default.createElement(S.Title, Object.assign({}, accessibility_1.accessibilityProps('bottom-sheet-title')), title)) : null,
            showCloseButton ? (react_1.default.createElement(S.CloseButton, Object.assign({ disabled: disableCloseButton, onPress: !disableCloseButton ? handleClosePress : () => { } }, accessibility_1.accessibilityProps('bottom-sheet-close-btn')),
                react_1.default.createElement(atoms_1.Remove, null))) : null)));
};
